export default __webpack_public_path__ + "static/heattech_homepage-1f0b3c774517553ca27ea00da7893cba.png";